/**
 * Newsletter Anmeldung Mailchimp
 *
 * Mailchimp schreibt die Success- oder Error-Meldung in ein jeweiliges <div>
 *
 * div#mce-error-response: errors
 * div#mce-success-response: success
 *
 * Bei diesen <div>s wird überwacht, ob sich der Inhalt ändert.
 *
 * Je nach Inhalt wird dann die entsprechende Erfolgs- oder Fehlermeldung angezeigt
 *
 * Bei einem Erfolg wird das Fomular ausgeblendet und durch die Erfolgs-Meldung ersetzt
 *
 * Bei einer Fehlermeldung wird diese eingeblendet, das Formualr bleibt.
 *
 */
$(document).ready(function () {
  if ($('.newsletter').length > 0) {
    newsletter.init();
  }
});

var newsletter = {
  init: function () {
      var error_response = true;
      var success_response = true;

    // errors from mailchimp
    $('#mce-error-response').on('DOMSubtreeModified', function () {
        if(error_response){
            // Hide the form
            $('#mc-embedded-subscribe-form').hide();


            // read the mailchimp error response
            var mailchimpResponse = $(this).get(0).innerText;

            if(mailchimpResponse != ''){
                $('.mce-success-response').hide();

                // translate the mailchimp error response

                // default error message
                var geystErrorResponse = 'mailchimp_default_error_response';

                // To many attempts
                if (mailchimpResponse.indexOf('has too many recent signup requests') !== -1) {
                    geystErrorResponse = 'mailchimp_tomanysignup_requests';
                }

                // Email is already exists
                if (mailchimpResponse.indexOf('is already subscribed to list') !== -1) {
                    geystErrorResponse = 'mailchimp_already_subscribed';
                }

                // Email already subscribed, original Mailchim response =>  'xxx@yyy.com bereits auf der Liste angemeldet Mechtop AG. Hier klicken, um Ihr Profil zu aktualisieren'
                if (mailchimpResponse.indexOf('bereits auf der Liste angemeldet') > 0) {
                    geystErrorResponse = 'mailchimp_already_subscribed';
                }

                if(geystErrorResponse == 'mailchimp_tomanysignup_requests') {
                    $('.mce-error-response_tomanysignup').show();
                } else if (geystErrorResponse == 'mailchimp_already_subscribed') {
                    $('.mce-error-response_alreadysubscribed').show();
                } else {
                    $('.mce-error-response_default').show();
                }

                // Append the original Mailchimp error in hidden field
                $('.mailchimp-responses').append('<p class="mailchimp-error">' + mailchimpResponse + '</p>');
            } else {
                if($("#mce-success-response").get(0).innerText != ''){
                    $('.mce-success-response').show();
                    $('.mce-error-response').hide();
                }
            }

            error_response = false;
        }



    });

    // success from mailchimp
    $('#mce-success-response').on('DOMSubtreeModified', function () {

      if(success_response){
          // hide the form
          $('#mc-embedded-subscribe-form').hide();

          $('.mce-success-response').show();
          $('.mce-error-response').hide();

          success_response = false;
      }

    });
  }
};
